import { NotificationService } from '@cradua/core';
import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { map, catchError, concatMap, exhaustMap, tap } from 'rxjs/operators';
import { of } from 'rxjs';
import * as ProgressHistoryActions from './progress-history.actions';
import { ProgressHistoryService } from '../../services/progress-history.service';
import { Router } from '@angular/router';

@Injectable()
export class ProgressHistoryEffects {
  loadProgressHistory$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProgressHistoryActions.loadProgressHistory),
      exhaustMap((_) =>
        this.progressHistoryService.getProgressHistory().pipe(
          map((data) =>
            ProgressHistoryActions.loadProgressHistorySuccess({
              progressHistory: data,
            })
          ),
          catchError((error) => {
            if (error.statusText === 'Unknown Error') {
              this.notification.error(
                'Unable to get response from server, please try again'
              );
            }

            return of(
              ProgressHistoryActions.loadProgressHistoryFailure({
                error,
              })
            );
          })
        )
      )
    )
  );

  addProgressHistory$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProgressHistoryActions.addProgressHistory),
      concatMap(({ newProgressHistory }) =>
        this.progressHistoryService
          .createProgressHistory(newProgressHistory)
          .pipe(
            map((data) => {
              this.notification.success('Saved Successfully');
              return ProgressHistoryActions.addProgressHistorySuccess({
                newProgressHistory: data,
              });
            }),
            catchError((error) => {
              console.log('error ', error);

              return of(
                ProgressHistoryActions.addProgressHistoryFailure({
                  error: error.error.message,
                })
              );
            })
          )
      )
    )
  );

  // addSuccess$ = createEffect(
  // 	() =>
  // 		this.actions$.pipe(
  // 			ofType(ProgressHistoryActions.addProgressHistorySuccess),
  // 			tap(() => {
  // 				return this.router.navigate([ '/project' ]);
  // 			})
  // 		),
  // 	{ dispatch: false }
  // );

  updateProgressHistory$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProgressHistoryActions.updateProgressHistory),
      concatMap(({ updateProgressHistory }) =>
        this.progressHistoryService
          .updateProgressHistory(updateProgressHistory)
          .pipe(
            map((data) => {
              // console.log('update effect data ', data);
              this.notification.success('Updated Successfully');
              return ProgressHistoryActions.updateProgressHistorySuccess({
                updateProgressHistory: data,
              });
            }),
            catchError((error) => {
              return of(
                ProgressHistoryActions.updateProgressHistoryFailure({
                  error: error.message,
                })
              );
            })
          )
      )
    )
  );

  updateSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(ProgressHistoryActions.updateProgressHistorySuccess),
        tap(() => {
          console.log('navigate');
          return this.router.navigate(['/project']);
        })
      ),
    { dispatch: false }
  );

  removeProgressHistory$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProgressHistoryActions.removeProgressHistory),
      map((action) => action.ids),
      concatMap((ids) =>
        this.progressHistoryService.deleteProgressHistory(ids).pipe(
          map(() => {
            this.notification.success('Deleted Successfully');
            return ProgressHistoryActions.removeProgressHistorySuccess({ ids });
          }),
          catchError((error) =>
            of(
              ProgressHistoryActions.updateProgressHistoryFailure({
                error: error.message,
              })
            )
          )
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private progressHistoryService: ProgressHistoryService,
    private notification: NotificationService,
    private router: Router
  ) {}
}
